import React from 'react'
import { Clock, MapPin, Users, TrendingUp } from 'lucide-react'

const Projects = () => {
  const ongoingProjects = [
    {
      id: 1,
      title: 'Skyline Residences',
      location: 'Mumbai, Maharashtra',
      type: 'Residential Complex',
      image: 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80',
      progress: 75,
      startDate: 'Jan 2024',
      expectedCompletion: 'Jun 2025',
      teamSize: 8,
      description: 'Luxury residential complex with 50 premium apartments featuring modern amenities and sustainable design.'
    },
    {
      id: 2,
      title: 'Tech Hub Office',
      location: 'Bangalore, Karnataka',
      type: 'Commercial',
      image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?w=800&q=80',
      progress: 60,
      startDate: 'Mar 2024',
      expectedCompletion: 'Sep 2025',
      teamSize: 12,
      description: 'State-of-the-art office space for a leading technology company with collaborative workspaces and innovation labs.'
    },
    {
      id: 3,
      title: 'Heritage Hotel Restoration',
      location: 'Jaipur, Rajasthan',
      type: 'Hospitality',
      image: 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=800&q=80',
      progress: 45,
      startDate: 'Feb 2024',
      expectedCompletion: 'Dec 2025',
      teamSize: 15,
      description: 'Restoration and modernization of a historic property while preserving its cultural heritage and architectural beauty.'
    },
    {
      id: 4,
      title: 'Wellness Retreat Center',
      location: 'Goa',
      type: 'Hospitality',
      image: 'https://images.unsplash.com/photo-1571896349842-33c89424de2d?w=800&q=80',
      progress: 30,
      startDate: 'Apr 2024',
      expectedCompletion: 'Mar 2026',
      teamSize: 10,
      description: 'Holistic wellness center featuring spa facilities, yoga studios, and meditation spaces in a serene coastal setting.'
    },
    {
      id: 5,
      title: 'Urban Loft Conversion',
      location: 'Delhi NCR',
      type: 'Residential',
      image: 'https://images.unsplash.com/photo-1600607687644-c7171b42498f?w=800&q=80',
      progress: 85,
      startDate: 'Nov 2023',
      expectedCompletion: 'Apr 2025',
      teamSize: 6,
      description: 'Converting industrial warehouse space into modern luxury lofts with open-plan living and industrial-chic aesthetics.'
    },
    {
      id: 6,
      title: 'Boutique Retail Space',
      location: 'Pune, Maharashtra',
      type: 'Commercial',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800&q=80',
      progress: 50,
      startDate: 'Feb 2024',
      expectedCompletion: 'Aug 2025',
      teamSize: 7,
      description: 'High-end retail space design for luxury fashion brand with immersive customer experience zones.'
    }
  ]

  return (
    <div data-component-path="client/src/pages/Projects.jsx" data-component-line="1:1" data-component-id="client/src/pages/Projects.jsx:1:1" className="pt-20">
      <section data-component-path="client/src/pages/Projects.jsx" data-component-line="2:3" data-component-id="client/src/pages/Projects.jsx:2:3" className="py-20 bg-white">
        <div data-component-path="client/src/pages/Projects.jsx" data-component-line="3:5" data-component-id="client/src/pages/Projects.jsx:3:5" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-path="client/src/pages/Projects.jsx" data-component-line="4:7" data-component-id="client/src/pages/Projects.jsx:4:7" className="text-center mb-12">
            <h1 data-component-path="client/src/pages/Projects.jsx" data-component-line="5:9" data-component-id="client/src/pages/Projects.jsx:5:9" className="text-5xl md:text-6xl font-bold text-gray-900 mb-6 hero-title">Ongoing Projects</h1>
            <p data-component-path="client/src/pages/Projects.jsx" data-component-line="6:9" data-component-id="client/src/pages/Projects.jsx:6:9" className="text-xl text-gray-600 max-w-3xl mx-auto">
              Get a glimpse into our current projects and see the transformation in progress
            </p>
          </div>

          <div data-component-path="client/src/pages/Projects.jsx" data-component-line="7:7" data-component-id="client/src/pages/Projects.jsx:7:7" className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            {ongoingProjects.map((project) => (
              <div data-component-path="client/src/pages/Projects.jsx" data-component-line="8:9" data-component-id="client/src/pages/Projects.jsx:8:9"
                key={project.id}
                className="bg-stone-50 rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300"
              >
                <div data-component-path="client/src/pages/Projects.jsx" data-component-line="9:11" data-component-id="client/src/pages/Projects.jsx:9:11" className="relative h-64 overflow-hidden">
                  <img data-component-path="client/src/pages/Projects.jsx" data-component-line="10:13" data-component-id="client/src/pages/Projects.jsx:10:13"
                    src={project.image}
                    alt={project.title}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    onError={(e) => {
                      e.target.src = 'https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=800&q=80'
                    }}
                  />
                  <div data-component-path="client/src/pages/Projects.jsx" data-component-line="11:13" data-component-id="client/src/pages/Projects.jsx:11:13" className="absolute top-4 right-4 bg-amber-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {project.type}
                  </div>
                  <div data-component-path="client/src/pages/Projects.jsx" data-component-line="12:13" data-component-id="client/src/pages/Projects.jsx:12:13" className="absolute bottom-4 left-4 right-4 bg-white/95 backdrop-blur-sm rounded-lg p-3">
                    <div data-component-path="client/src/pages/Projects.jsx" data-component-line="13:15" data-component-id="client/src/pages/Projects.jsx:13:15" className="flex items-center justify-between mb-2">
                      <span data-component-path="client/src/pages/Projects.jsx" data-component-line="14:17" data-component-id="client/src/pages/Projects.jsx:14:17" className="text-sm font-medium text-gray-700">Progress</span>
                      <span data-component-path="client/src/pages/Projects.jsx" data-component-line="15:17" data-component-id="client/src/pages/Projects.jsx:15:17" className="text-sm font-bold text-amber-600">{project.progress}%</span>
                    </div>
                    <div data-component-path="client/src/pages/Projects.jsx" data-component-line="16:15" data-component-id="client/src/pages/Projects.jsx:16:15" className="w-full bg-gray-200 rounded-full h-2">
                      <div data-component-path="client/src/pages/Projects.jsx" data-component-line="17:17" data-component-id="client/src/pages/Projects.jsx:17:17"
                        className="bg-amber-600 h-2 rounded-full transition-all duration-500"
                        style={{ width: `${project.progress}%` }}
                      ></div>
                    </div>
                  </div>
                </div>

                <div data-component-path="client/src/pages/Projects.jsx" data-component-line="18:11" data-component-id="client/src/pages/Projects.jsx:18:11" className="p-6">
                  <h3 data-component-path="client/src/pages/Projects.jsx" data-component-line="19:13" data-component-id="client/src/pages/Projects.jsx:19:13" className="text-2xl font-bold text-gray-900 mb-2 hero-title">{project.title}</h3>
                  <div data-component-path="client/src/pages/Projects.jsx" data-component-line="20:13" data-component-id="client/src/pages/Projects.jsx:20:13" className="flex items-center gap-2 text-gray-600 mb-4">
                    <MapPin data-component-path="client/src/pages/Projects.jsx" data-component-line="21:15" data-component-id="client/src/pages/Projects.jsx:21:15" className="w-4 h-4 flex-shrink-0" />
                    <span data-component-path="client/src/pages/Projects.jsx" data-component-line="22:15" data-component-id="client/src/pages/Projects.jsx:22:15" className="text-sm">{project.location}</span>
                  </div>
                  <p data-component-path="client/src/pages/Projects.jsx" data-component-line="23:13" data-component-id="client/src/pages/Projects.jsx:23:13" className="text-gray-600 mb-6 leading-relaxed">{project.description}</p>

                  <div data-component-path="client/src/pages/Projects.jsx" data-component-line="24:13" data-component-id="client/src/pages/Projects.jsx:24:13" className="grid grid-cols-2 gap-4 pt-4 border-t border-gray-200">
                    <div data-component-path="client/src/pages/Projects.jsx" data-component-line="25:15" data-component-id="client/src/pages/Projects.jsx:25:15" className="flex items-start gap-3">
                      <Clock data-component-path="client/src/pages/Projects.jsx" data-component-line="26:17" data-component-id="client/src/pages/Projects.jsx:26:17" className="w-5 h-5 text-amber-600 flex-shrink-0 mt-1" />
                      <div data-component-path="client/src/pages/Projects.jsx" data-component-line="27:17" data-component-id="client/src/pages/Projects.jsx:27:17">
                        <p data-component-path="client/src/pages/Projects.jsx" data-component-line="28:19" data-component-id="client/src/pages/Projects.jsx:28:19" className="text-xs text-gray-500 mb-1">Timeline</p>
                        <p data-component-path="client/src/pages/Projects.jsx" data-component-line="29:19" data-component-id="client/src/pages/Projects.jsx:29:19" className="text-sm font-medium text-gray-900">{project.startDate} - {project.expectedCompletion}</p>
                      </div>
                    </div>
                    <div data-component-path="client/src/pages/Projects.jsx" data-component-line="30:15" data-component-id="client/src/pages/Projects.jsx:30:15" className="flex items-start gap-3">
                      <Users data-component-path="client/src/pages/Projects.jsx" data-component-line="31:17" data-component-id="client/src/pages/Projects.jsx:31:17" className="w-5 h-5 text-amber-600 flex-shrink-0 mt-1" />
                      <div data-component-path="client/src/pages/Projects.jsx" data-component-line="32:17" data-component-id="client/src/pages/Projects.jsx:32:17">
                        <p data-component-path="client/src/pages/Projects.jsx" data-component-line="33:19" data-component-id="client/src/pages/Projects.jsx:33:19" className="text-xs text-gray-500 mb-1">Team Size</p>
                        <p data-component-path="client/src/pages/Projects.jsx" data-component-line="34:19" data-component-id="client/src/pages/Projects.jsx:34:19" className="text-sm font-medium text-gray-900">{project.teamSize} Members</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default Projects